import React from 'react';
import { useHistory } from 'react-router-dom';
import css from './MissionSection.module.css';
import Button from '../Button/Button';
import RocketIcon from '../Icons/RocketIcon';
import missionBackground from '../../../../assets/how-it-works-section-3.png';

const MissionSection = () => {
  const history = useHistory();

  return (
    <div className={css.section} style={{ backgroundImage: `url(${missionBackground})` }}>
      <div className={css.contentContainer}>
        <div className={css.content}>
          <div className={css.header}>
            <RocketIcon className={css.icon} color="white" />
            <div className={css.title}>Our Mission</div>
          </div>

          <p className={css.paragraph}>
            Grounddz exist to make martial arts more accessible to everyone.
            We believe that cost should not be a barrier to training and
            community is essential for growth.
          </p>

          <p className={css.paragraph}>
            By providing a trusted space for practitioners to buy and sell
            quality gear at fair prices, and to discover local training
            opportunities, we're helping build a stronger, more
            connected martial arts community for all ages and skill levels.
          </p>

          <p className={css.paragraph}>
            Choosing Grounddz also means choosing sustainability. By
            encouraging reuse and conscious consumption, we reduce waste and
            promote a greener planet.
          </p>

          <Button
            variant="secondary"
            text="Learn more about our work"
            onClick={() => history.push('/p/about')}
          />
        </div>
      </div>
    </div>
  );
};

export default MissionSection;

